import { render } from "./RecipeView.vue?vue&type=template&id=40c4c51e&scoped=true"
import script from "./RecipeView.vue?vue&type=script&lang=js"
export * from "./RecipeView.vue?vue&type=script&lang=js"

import "./RecipeView.vue?vue&type=style&index=0&id=40c4c51e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2503735441/src/recipe-ai-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c4c51e"]])

export default __exports__